import Api from "./api";

class MapConfigApi {
	static get = (projectSchema) => {
		const url = `mapconfig/${projectSchema}`;
		return Api
			.get(url)
			.then(response => {
				return response.data;
			});
	};
}

export default MapConfigApi;